import { useEffect } from 'react';
import confetti from 'canvas-confetti';

export const fireConfetti = () => {
  // Gold and premium colors
  const colors = ['#c9a227', '#ffd700', '#ffffff', '#f0e68c'];
  
  const end = Date.now() + 2000;

  const frame = () => {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.8 },
      colors: colors,
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.8 },
      colors: colors,
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };

  frame();
};

export const fireSuccessConfetti = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#c9a227', '#ffd700', '#10b981', '#ffffff'],
  });
};

export default function Confetti({ trigger }) {
  useEffect(() => {
    if (trigger) {
      fireConfetti();
    }
  }, [trigger]);

  return null;
}
